import { all, takeLatest } from 'redux-saga/effects';

import { fetchRoles } from 'actions/roles';

import { fetchRolesSaga } from './fetchRoles';

export default function* rolesSaga() {
  yield all([takeLatest(fetchRoles, fetchRolesSaga)]);
}
